import { FindSerialSequenceDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export const useSerialSequence = (serialSequenceId: string, isOpen: boolean) => {
  const {
    data: foundData,
    loading,
    error,
  } = useQuery(FindSerialSequenceDocument, {
    variables: { id: serialSequenceId },
    skip: !isOpen,
  })

  const serialSequence =
    foundData?.finance?.salesInvoiceSequence || foundData?.finance?.creditNoteSequence || foundData?.finance?.quoteSequence

  return {
    serialSequence,
    loading,
    error,
    notFound: !loading && !error && !serialSequence,
  }
}
